<template>
  <div id="app">
    <div
      v-if="
        this.$router.currentRoute.path !== '/' &&
        this.$router.currentRoute.path !== '/tester'
      "
    >
      <NavigationBar />
      <Print />
    </div>
    <router-view />
  </div>
</template>

<script>

import NavigationBar from "./components/Navigation/Index-Navigation.vue";
import Print from "./components/Print/Print.vue";

export default {
  name: "App",
  components: {
    NavigationBar,
    Print,
  },
  data() {
    return {};
  },
  methods: {
  },
};
</script>

<style>
* {
  font-family: Poppins-Medium, sans-serif !important;
}

@font-face {
  font-family: Poppins-Regular;
  src: url("~@/fonts/poppins/Poppins-Regular.ttf");
}

@font-face {
  font-family: Poppins-Bold;
  src: url("~@/fonts/poppins/Poppins-Bold.ttf");
}

@font-face {
  font-family: Poppins-Medium;
  src: url("~@/fonts/poppins/Poppins-Medium.ttf");
}

@font-face {
  font-family: Montserrat-Bold;
  src: url("~@/fonts/montserrat/Montserrat-Bold.ttf");
}

*::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

*::-webkit-scrollbar-track {
  background: white;
}

*::-webkit-scrollbar-thumb {
  background-color: #3a4750;
  border-radius: 2px;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  padding: 5px;
  filter: invert(0.8) brightness(250%) sepia(0%) saturate(10%)
    hue-rotate(240deg);
  background-color: #d5d3d3;
  border-radius: 50%;
}

body {
  /* background: #102558 !important; */
  background-color: rgb(255, 255, 255) !important;
  margin: 0;
  padding: 0;
}
</style>
